import type {StripeContextInput} from '../../../schema/types';
import {
  ACCOUNT_ACTIVE_CONTEXT_REGEXP,
  ORG_ACTIVE_CONTEXT_REGEXP,
  PLAYGROUND_ACTIVE_CONTEXT_REGEXP,
} from './constants';
import getOrgUnverifiedToken from './getOrgUnverifiedToken';
import getAccountUnverifiedToken from './getAccountUnverifiedToken';
import getUnknownUnverifiedToken from './getUnknownUnverifiedToken';
import type {SharedUnverifiedToken} from './types';
import getPlaygroundUnverifiedToken from './getPlaygroundUnverifiedToken';

export default function getV2UnverifiedToken(
  id?: NonNullable<StripeContextInput['id']>,
  liveMode?: NonNullable<StripeContextInput['liveMode']>,
  apiKey?: NonNullable<StripeContextInput['apiKey']>,
): SharedUnverifiedToken {
  // Ideally, the backend should return us the type of compartment
  // along with the token permissions so we don't need to infer the
  // type of token based on the id.
  // Note also that with this logic, any token generated from a
  // compartment will be created as unknown.
  if (id && ORG_ACTIVE_CONTEXT_REGEXP.test(id)) {
    return getOrgUnverifiedToken(id, liveMode, apiKey);
  }

  if (id && PLAYGROUND_ACTIVE_CONTEXT_REGEXP.test(id)) {
    return getPlaygroundUnverifiedToken(id, liveMode, apiKey);
  }

  if (id && ACCOUNT_ACTIVE_CONTEXT_REGEXP.test(id)) {
    return getAccountUnverifiedToken(id, liveMode, apiKey);
  }

  return getUnknownUnverifiedToken(id, liveMode, apiKey);
}
